import { BfiApi, IApiResponse } from './bfiApi';
import { IAddress } from 'libs/store/src/cross';

// eslint-disable-next-line no-undef
export interface IAppraisersListItemResponse extends Omit<IApiResponse, 'result'> {
    result: IAppraiserListItem;
}

export interface IAppraisersListResponse extends Omit<IApiResponse, 'result'> {
    result: {
        totalCount: number;
        results: [IAppraiser];
    };
}

export interface IAppraiserNamesValidationResponse extends Omit<IApiResponse, 'result'> {
    result: boolean;
}

export interface IAppraiserResponse extends Omit<IApiResponse, 'result'> {
    result: IAppraiser;
}

export interface IAppraiserListItem {
    key: number;
    name: string;
}

export interface IAppraiser {
    id?: number;
    companyName: string;
    displayName: string;
    lastName: string;
    firstName: string;
    email: string;
    phone: string;
    mailingAddress: IAddress;
}

export interface IAppraiserNames {
    companyName: string;
    lastName: string;
    firstName: string;
    ignoreId: number;
}

export interface ISortColumn {
    column: string;
    direction: string;
}

export interface ISearchCriteria {
    searchText: string;
    skip: number;
    take: number;
    sorting: ISortColumn;
}

export interface IAppraisalReviewerListItem {
    key: number;
    name: string;
}

export interface IAppraisalReviewer {
    id?: number;
    lastName: string;
    firstName: string;
    email: string;
    phone: string;
}

export class AppraisalsApi extends BfiApi {
    getAppraiser(id: number): Promise<IAppraiserResponse> {
        return super.get(`/appraisals/appraisers/${id ?? ''}`);
    }

    addUpdateAppraiser(appraiser: IAppraiser): Promise<IAppraiserResponse> {
        return super.post('/appraisals/appraisers', appraiser);
    }

    validateNames(names: IAppraiserNames): Promise<IAppraiserNamesValidationResponse> {
        return super.post('/appraisals/appraisers/validatenames', names);
    }

    search(searchText: string, pageNumber: number, pageSize: number): Promise<IAppraisersListItemResponse> {
        return super.get(
            `/appraisals/appraisers/search?searchText=${searchText ?? ''}&pageNumber=${pageNumber ?? 1}&pageSize=${pageSize ?? 50}`
        );
    }

    getActiveList(criteria: ISearchCriteria): Promise<IAppraisersListResponse> {
        return super.post(`/appraisals/appraisers/active`, criteria);
    }

    getInActiveList(criteria: ISearchCriteria): Promise<IAppraisersListResponse> {
        return super.post(`/appraisals/appraisers/inactive`, criteria);
    }

    restoreAppraiser(id: number): Promise<IApiResponse> {
        return super.put(`/appraisals/appraisers/${id ?? ''}/restore`);
    }

    deleteAppraiser(id: number): Promise<IApiResponse> {
        return super.delete(`/appraisals/appraisers/${id ?? ''}`);
    }

    appraisalReviewerGet(id: number): Promise<IApiResponse> {
        return super.get(`/appraisals/reviewers/${id ?? ''}`);
    }

    appraisalReviewerSet(reviewer: IAppraisalReviewer): Promise<IApiResponse> {
        return super.post('/appraisals/reviewers', reviewer);
    }

    appraisalReviewersList(includeId: number): Promise<IApiResponse> {
        return super.get(`/appraisals/reviewers/list?includeId=${includeId ?? ''}`);
    }

    appraisalReviewersGrid(criteria: ISearchCriteria): Promise<IApiResponse> {
        return super.post('/appraisals/reviewers/grid', criteria);
    }

    validateAppraisalReviewer(reviewer: IAppraisalReviewer): Promise<IApiResponse> {
        return super.post('/appraisals/reviewers/validate', reviewer);
    }
}
